import { Link } from "react-router-dom";

const Button = ({ children, link, IconBefore, IconAfter, variant, onclick }) => {
  return (
    <div className={'button ' + (variant ?? '')}>
      <Link to={link} onClick={onclick}>
        {IconBefore && <IconBefore className="icon-before"/>}
        { children }
        {IconAfter && <IconAfter className="icon-after"/>}
      </Link>
    </div>
  )
}

export default Button;